import { useEffect, useState } from 'react'
import { MapEmbed as View } from 'ui-components'
import { getEmbedMapLink } from 'utils'
import { deleteEmbedMap } from '~map-preview/api/deleteEmbedMap'
import { embedMap } from '~map-preview/api/embedMap'
import { useMapEmbedLink } from '~map-preview/hooks/useMapEmbedLink'
import { useMap } from '~map-preview/states/map'

export const Embed = () => {
  const mapData = useMap()
  const initialLink = useMapEmbedLink()
  const [link, setLink] = useState<string | undefined>(initialLink)

  useEffect(() => {
    if (!mapData?.id) return
    !mapData.embedKey &&
      embedMap({ mapId: mapData?.id }).then((result) => {
        setLink(getEmbedMapLink({ ...mapData, embedKey: result }))
      })
  }, [mapData])

  const handleEmbedClick = async () => {
    if (!mapData?.id) return
    const result = await embedMap({ mapId: mapData?.id })
    setLink(getEmbedMapLink({ ...mapData, embedKey: result }))
  }

  const handleDeleteEmbedClick = async () => {
    if (!mapData?.id) return
    const result = await deleteEmbedMap({ mapId: mapData?.id })
    if (!result) {
      console.warn('Failed to delete embed map!')
      return
    }
    setLink(undefined)
  }

  const handleCopyClick = () => {}

  return (
    <View
      hideDeleteLink={mapData.isPublic}
      link={link}
      onCopyClick={handleCopyClick}
      onEmbedClick={handleEmbedClick}
      onDeleteClick={handleDeleteEmbedClick}
    />
  )
}
